export class Contrato {
    id: number;
    nome: string;
    ativo: boolean = true;
}
